/* eslint-env babel */

import React from "react";
import PropTypes from "prop-types";
import "./ResponsiveGrid.scss";

// import ReactSwitch from "react-switch";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faSearch, faMapMarkedAlt, faList, faDownload } from "@fortawesome/free-solid-svg-icons";

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // screenSscreenSize: "desktop",

            pageClass: "layout_page_start",
            selectedMobileContainer: "map",
            zIndex_main: 3,
            zIndex_search: 3,
            zIndex_list: 3,
            zIndex_mobileMenuBar: 3
        };
        this.toggleMobileView = this.toggleMobileView.bind(this);
        this.defaultContainerClass = "layout_container layout_gridItem" + (this.props.showBorders ? " layout_container_withBorders" : "");
    }

    componentDidUpdate(oldProps) {
        let _this = this;
        const newProps = this.props;
        if (oldProps.screenSize !== newProps.screenSize || oldProps.isLoading !== newProps.isLoading || oldProps.startScreenVisible !== newProps.startScreenVisible) {
            this.setZIndexes();
        }
        if (this.props.searchRun) {
            this.setState(
                {
                    selectedMobileContainer: "map"
                },
                _this.setZIndexes
            );
        }
    }
    componentDidMount() {
        this.setZIndexes();
    }

    render() {
        return (
            <figure className="layout_wrapper" style={{ height: this.props.height, width: this.props.width }}>
                <div className="layout_loading" style={{ display: this.props.isLoading ? "block" : "none", lineHeight: this.props.height.toString() + "px" }}>
                    <FontAwesomeIcon icon={faSpinner} spin size="6x" />
                </div>
                <div className={"layout_" + this.props.screenSize} style={{ gridTemplateColumns: this.props.screenSize === "mobile" ? "auto" : (this.props.leftSidebarWidth + "px auto " + this.props.rightSidebarWidth + "px") }}>
                    <div className="layout_startScreen" style={{ display: this.props.startScreenVisible ? "block" : "none" }}>
                        <div className={this.defaultContainerClass + " layout_startPhoto layout_container_startPhoto"} style={{ display: this.props.startScreenVisible ? "block" : "none", backgroundImage: "url(" + this.props.coverPhoto + ")" }}>
                            {this.renderContainer_startScreenContent()}
                            <div className="layout_startPhoto_overlay" />
                            <div className="layout_startPhoto_attribution">{this.props.coverPhoto_credits}</div>
                        </div>
                    </div>
                    {this.renderContainer_header()}
                    {this.renderContainer_leftSidebar()}
                    {this.renderContainer_rightSidebar()}
                    {this.renderContainer_main()}
                    {this.renderContainer_mobileMenuBar()}
                </div>
            </figure>
        );
    }

    renderContainer_startScreenContent() {
        return <div className={this.defaultContainerClass + " layout_container_startScreenContent"}>{this.props.element_startScreenContent}</div>;
    }
    containerDisplay(containerName) {
        if (this.props.screenSize !== "mobile") {
            return containerName === "header" ? "grid" : "block";
        } else if (containerName === this.state.selectedMobileContainer) {
            return containerName === "header" ? "grid" : "block";
        } else {
            // return "none";
            return "block";
        }
    }

    setZIndexes() {
        let zI_main = 3,
            zI_list = 3,
            zI_search = -999,
            zI_mobileMenuBar = -999;
        if (!this.props.isLoading) {
            if (this.props.screenSize === "mobile") {
                zI_mobileMenuBar = 3;
                if (this.state.selectedMobileContainer === "header") {
                    zI_search = 3;
                } else if (this.state.selectedMobileContainer === "map") {
                    zI_main = 2;
                } else if (this.state.selectedMobileContainer === "sidebar") {
                    zI_list = 2;
                }
            } else {
                zI_search = 3;
                zI_main = 1;
                zI_list = 2;
            }
        }

        this.setState({
            zIndex_main: zI_main,
            zIndex_list: zI_list,
            zIndex_search: zI_search,
            zIndex_mobileMenuBar: zI_mobileMenuBar
        });
    }

    renderContainer_header() {
        let headerContent = this.props.element_header || this.props.text_title;
        return <header className={this.defaultContainerClass + " layout_container_title"}>{headerContent}</header>;
    }

    renderContainer_main() {
        return (
            // <main className={this.defaultContainerClass + " layout_container_main"} style={{ display: this.containerDisplay("map") , zIndex:this.containerZIndex("map")}}>
            <main className={this.defaultContainerClass + " layout_container_main"} style={{ zIndex: this.state.zIndex_main }}>
                {this.props.element_main}
            </main>
        );
    }
    // renderContainer_mobileMapDownloadButton() {
    //     return (
    //         // <main className={this.defaultContainerClass + " layout_container_main"} style={{ display: this.containerDisplay("map") , zIndex:this.containerZIndex("map")}}>
    //         <main className={this.defaultContainerClass + " layout_container_mobileMapDownloadButton"} style={{ zIndex: this.state.zI_mainMobileDownloadButton }}>
    //             {this.props.element_mobileMapDownloadButton}
    //         </main>
    //     );
    // }
    renderContainer_leftSidebar() {
        return (
            <aside
                className={this.defaultContainerClass + " layout_container_leftSidebar" + (this.props.mapVisible ? " " + this.defaultContainerClass + " layout_container_leftSidebar_mainVisible" : "")}
                style={{ zIndex: this.state.zIndex_list, position: "relative" }}
            >
                {this.props.element_leftSidebar}
            </aside>
        );
    }
    renderContainer_rightSidebar() {
        if (this.props.element_rightSidebar) {
            return (
                // <aside className={this.defaultContainerClass + " layout_container_rightSidebar"} style={{ display: this.containerDisplay("sidebar") , zIndex:this.containerZIndex("sidebar")}}>
                <aside className={this.defaultContainerClass + " layout_container_rightSidebar"} style={{ zIndex: this.state.zIndex_list, position: "relative" }}>
                    {this.props.element_rightSidebar}
                </aside>
            );
        } else {
            return null;
        }
    }
    renderContainer_mobileMenuBar() {
        if (this.props.screenSize !== "mobile") {
            return null;
        }
        return (
            <nav className={this.defaultContainerClass + " layout_container_mobileMenuBar"} style={{ zIndex: this.state.zIndex_mobileMenuBar }}>
                <div className="layout_mobileMenuItems">{this.props.element_mobileMenuItems}</div>
            </nav>
        );
    }

    toggleMobileView(checked) {
        this.setState({ selectedMobileContainer: checked ? "sidebar" : "map" }, this.setZIndexes);
    }
}

Layout.propTypes = {
    screenSize: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isLoading: PropTypes.bool.isRequired,
    text_title: PropTypes.string,
    mapVisible: PropTypes.bool,
    coverPhoto: PropTypes.string,
    coverPhoto_credits: PropTypes.element,

    /** Show a border around all containers. Can be helpful for testing purposes.*/
    showBorders: PropTypes.bool,

    startScreenVisible: PropTypes.bool,
    searchRun: PropTypes.bool,

    /** The content that will appear in the header section and on the main page. Typically used for a search bar */
    element_startScreenContent: PropTypes.element,
    element_search: PropTypes.element,
    element_main: PropTypes.element,
    element_header:PropTypes.element,
    element_rightSidebar: PropTypes.element,
    element_leftSidebar: PropTypes.element,
    element_mobileMapDownloadButton: PropTypes.element,
    element_mobileMenuItems: PropTypes.element,

    faObject_mobileMenuBarIcon_header: PropTypes.object,
    faObject_mobileMenuBarIcon_main: PropTypes.object,
    faObject_mobileMenuBarIcon_leftSidebar: PropTypes.object,
    faObject_mobileMenuBarIcon_rightSidebar: PropTypes.object,
    faObject_mobileMenuBarIcon_download: PropTypes.object,
    leftSidebarWidth: PropTypes.number,
    rightSidebarWidth: PropTypes.number
};
Layout.defaultProps = {
    height: "100vh",
    width: "100vw",
    showBorders: false,
    text_title: "text_title content",

    element_startScreenContent: <div>element_startScreenContent content</div>,
    element_search: <div>element_search content</div>,
    element_main: <div>element_main content</div>,
    // element_rightSidebar: <div>element_rightSidebar content</div>,
    element_leftSidebar: <div>element_leftSidebar content</div>,
    element_mobileMapDownloadButton: <div>element_mobileMapDownloadButton content</div>,
    faObject_mobileMenuBarIcon_header: faSearch,
    faObject_mobileMenuBarIcon_main: faMapMarkedAlt,
    faObject_mobileMenuBarIcon_rightSidebar: faList,
    faObject_mobileMenuBarIcon_download: faDownload,

    leftSidebarWidth: 340,
    rightSidebarWidth: 475
};

export default Layout;
